import {
  useCustomerApplicationsListSuspense,
  useCustomerLendersListSuspense,
} from "@boundless/bl-api-client/customer/services"
import { useCustomerApplicationsUpdate } from "@boundless/bl-api-client/customer/services"
import { CustomerApplicationsUpdateBody } from "@boundless/bl-api-client/customer/services.zod"
import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { ApplicationsTable } from "@/components/applications/ApplicationsTable"
import { Card } from "@/components/ui/card"

import type { z } from "zod"

export const Route = createFileRoute("/_dashboard/applications/")({
  component: RouteComponent,
  beforeLoad: ({ context: { store } }) => {
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/home" })
    }
    return { companyUuid }
  },
})

function RouteComponent() {
  const queryClient = useQueryClient()
  const { companyUuid } = Route.useRouteContext()
  const { data: applications, queryKey: customerApplicationsListQueryKey } =
    useCustomerApplicationsListSuspense(companyUuid)
  const { data: lenders } = useCustomerLendersListSuspense(companyUuid)
  const { mutate: toggleAccess } = useCustomerApplicationsUpdate({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: customerApplicationsListQueryKey,
        })
      },
    },
  })

  const handleUpdateApplication = (
    data: z.infer<typeof CustomerApplicationsUpdateBody>,
    uuid: string,
  ) => {
    toggleAccess({
      companyUuid: companyUuid,
      uuid: uuid,
      data: { ...data, repositoryAccessEnabled: !data.repositoryAccessEnabled },
    })
  }

  return (
    <Card className="p-6">
      {applications && lenders ? (
        <ApplicationsTable
          onToggle={handleUpdateApplication}
          applications={applications}
        />
      ) : (
        "No Applications found."
      )}
    </Card>
  )
}
